import React, { useState, useEffect }from 'react';
import { Toolbar, Grid, Button, Card, CardContent,makeStyles, } from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import KisshtTable from "components/table/KisshtTable";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import {fetchCityList} from "shared/api/configCity";
import CustomSelect from "components/custom/CustomSelect";
import ViewData from './dialog/ViewModal';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { PERMISSIONS, ROUTE_NAME } from 'shared/constants';
import PermissionButton from 'components/ui/form/PermissionButton';

const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 650,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));
  let offset = 1;


export const Cities = (props) => {

    const { params, updateQueryParams, delteQueryParams } = props;
    const classes = useStyles();
    const [search, setSearch] = useState(params["search"] || "");
    const [spinning, setSpinning] = useState(false);
    const [cityList, setCityList] = useState(false);
    const [openViewModal, setOpenAdViewModal] = useState(false);
    const [cityDataCount, setCityDataCount] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState(params["selectedFilter"] || "");
    const [reload, setReload] = useState(false);
    const [showCityData,setShowCityData] = useState(null)
    

    useEffect(() => {
        fetchCitiesList();
        offset = 1;
    }, [reload]);

    const refreshHandler = async (_) => {
      setSearch("");
      setCityList("");
      setSelectedFilter("");
      await delteQueryParams();
      offset = 1;
      setReload(!reload);
    };
    const handleSearch = async (e) => {
      e.preventDefault();
      if (!search.length){
        return false;
      }
      setSpinning(true);
      offset = 1;
      updateQueryParams({search});
      fetchCitiesList();
    };
    
 const fetchCitiesList = async () => {

    setSpinning(true);
    await updateQueryParams({ search });
    let data = getParam();
    fetchCityList(data)
      .then((res) => {
        setSpinning(false);
        if (res.hasOwnProperty("success") && res.success) {
          if (res?.data.list?.length > 0) {
            setCityList(res?.data.list);
            setCityDataCount(res?.data?.count);
          } else {
            setCityList([]);
          }
        }
      })
      .catch((error) => {
        setSpinning(false);
      });
  };
  const getParam = (_) => {
       
    let data = {
      "limit":20,
      "offset":offset - 1,
    };
   if(search){   
     if(selectedFilter === "state_name"){
      data = {
        "limit":20,
        "offset":offset - 1,
        "state_name" : search
      }
     }  
     else 
     if(selectedFilter === "city_name"){
      data = {
        "limit":20,
        "offset":offset - 1,
        "city_name" : search
      }
     }
   }
   return data;
 };

 const handleSelect = async (e) => {
  e.persist();
  if (e) {
    let item = e.target.value;
    if (!item) {
      setSearch("");
      await delteQueryParams();
      setReload(!reload);
    }
    setSelectedFilter(item);
    setSearch("");
  }
};

const viewHandle = (cell) =>{
    setShowCityData(cell.original);
    setOpenAdViewModal(true)
}  
const handleViewModalClosed = () => {
    setOpenAdViewModal(!openViewModal);
};  
  
const columns =[
    {
      Header: "City Name",
      accessor: "city_name",
      sortable: false,
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value}</span>
      }
    },
    {
      Header: "State Name",
      accessor: "state_name" ,
      sortable: false,
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value}</span>
      }
    },
    {
      Header: "Is Rufilo Live	",
      accessor: "is_kissht_live_drop" ,
      sortable: false,
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value === "0" ? "NO" : "YES"}</span>
      }
    },
    {
      Header: "Action",
      accessor: "id",
      filterable: false,
      sortable: false,
      width: "20",
      Cell: (cell) => {
            return (
                <Grid >
                  <Grid item style={{textAlign:"left"}}>  
                  <PermissionButton
                    endIcon={<VisibilityIcon />}
                    size="small"
                    variant="outlined"
                    style={{border:'none'}}
                    route={ROUTE_NAME.city}
                    permission={PERMISSIONS.city.city_view}
                    onClick={() => viewHandle(cell)}></PermissionButton>           
                  </Grid>
                </Grid>
            );
      },
      },
    ];

const onPageChange = async (value) => {
    offset = value;
    fetchCitiesList();
};
 

    return (
        <div>
        <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader  />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center" className='crum_padding'>
              <Grid item xs={12}>
                <Grid item xs={2}>
                    <BreadcrumbsHeader text="City Master List" />
                </Grid>
              </Grid>
              <Grid item xs={12} className="crum_innerPadding">
                <Grid container spacing={1} alignItems="center">
                    <Grid item className={classes.root}>
                      <CustomSelect
                        width="100px"
                        multiple={false}
                        options={{
                          city_name: "City",
                          state_name: "State",
                        }}
                        value={selectedFilter}
                        className="common_global_filter"
                        onChange={(e) =>  setSelectedFilter(e.target.value)}
                        nulloption="Select Filter Options"
                      />
                    </Grid>
                    <Grid item>
                      <CustomInput
                        placeholder="Enter Description"
                        maxwidth="200px"
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        className="common_custom_input"
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        disabled={selectedFilter && search ? false : true}
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        color="primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    </Grid> 
                    <Grid item>
                      <Button onClick={refreshHandler} size="small" color="primary">
                        Reset
                      </Button>
                    </Grid>
                </Grid>
              </Grid>

              </Grid>
          
        </Toolbar>
      </Header>

      <div className='common_padding_from_title_withLessFilter'>
      <Card style={{ boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,overflowX:'scroll'}} className={classes.card}>
        <CardContent className="p-1">
          <Grid container>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Grid style={{padding:"20px"}}>
                  </Grid>
                  <CardContent className='table_card_mobile'>
                    <KisshtTable
                      loading={spinning}
                      columns={columns}
                      data={cityList}
                      onPageChange={onPageChange}
                      showPagination={cityList.length > 0 ? true : false}
                      offset={offset}
                      totalCount={cityDataCount}
                    />
                  </CardContent>
                </Grid>
              </Grid>
          </Grid>
        </CardContent>
      </Card>
      <ViewData
            visible={openViewModal}
            handleDialogClose={() => handleViewModalClosed()}
            data={showCityData}
          />
      </div>    
    </div>
    )
}

export default Cities;


